import React from 'react';

const MiniAudioEqualizer: React.FC = () => {
  const bars = Array.from({ length: 6 }, (_, i) => (
    <div
      key={i}
      className="w-1 h-full rounded-sm animate-equalize bg-gradient-to-b from-[#547bb5] to-[#6e53b8]"
      style={{
        animationDelay: `${i * 0.1}s`,
        animationDuration: `${Math.random() * 0.5 + 0.5}s`,
      }}
    />
  ));

  return (
    <div className="flex items-center gap-1 h-4">
      {bars}
    </div>
  );
};

export { MiniAudioEqualizer }
